import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import "../../../styles/resource.scss";
import logo from "../../../asset/image/cards-graphic1.svg";
import Button from "react-bootstrap/Button";
import { LinkContainer } from "react-router-bootstrap";
import { TrialButton, TrialButtons } from "../../common/Buttons";
import { Helmet } from "react-helmet";
import { Route, useRouteMatch, Switch } from "react-router";
import Video from "./childComponent/Video";
import Literature from "./childComponent/Literature";
import { Link } from "react-router-dom";
import Compendium from "./childComponent/Compendium";

const Resource = () => {
  useEffect(() => {
    // window.scrollTo({
    //   top: 0,
    //   left: 0,
    // });
  }, []);
  const { path, url } = useRouteMatch();
  function tip() {
    return <h1>ok</h1>;
  }
  return (
    <div>
      {/* <Helmet>
        <meta charSet="utf-8" name="CloudSocial Resource page" />
        <meta
          name="description"
          content="Getting started videos and guides to know the step-by-step process for all the functionalities"
        />
        <title>Resource</title>
        <link rel="canonical" href="https://cloudsocial.io/resources/video" />
      </Helmet> */}
      {/* <div className="main-body">
        <div className="resource-content">
          <h1 className="title-resource">Resource</h1>
          <TrialButton />
          <div className="doted-pattern"></div>
        </div>
      </div>
      <div className="resource-image">
        <img src={logo} alt="" className="resourceContentImg" />
      </div> */}
      <div class="grid-container1">
        <div class="background">
          <div className="resource-content">
            <h1 className="title-resource">Resource</h1>
            <TrialButton />
            <div className="doted-pattern"></div>
          </div>
        </div>

        <div class="image">
          <div className="resource-image">
            <img src={logo} alt="" className="resourceContentImg" />
          </div>
        </div>
      </div>

      <div className="resource-toogle">
        <ButtonGroup aria-label="Basic example">
          <LinkContainer to="/resources/video">
            <Button variant="secondary" className="group-button">
              Getting started Videos
            </Button>
          </LinkContainer>
          <LinkContainer to="/resources/literature">
            <Button variant="secondary" className="group-button">
              Literature
            </Button>
          </LinkContainer>
          <LinkContainer to="/resources/compendium">
            <Button variant="secondary" className="group-button">
              Quick Start Compendium
            </Button>
          </LinkContainer>
        </ButtonGroup>
      </div>
      <br />
      <br />
      {/* <h2 className="title-social">CloudSocial Resources</h2> */}
      <Switch>
        <Route path="/resources/video" component={Video} />
        <Route path="/resources/literature" component={Literature} />
        <Route path="/resources/compendium" component={Compendium} />
      </Switch>
      <div style={{ display: "none" }}>
        {/* <Link to="/test">test</Link>
        <Link to="/search_gcse">search_gcse</Link>
        <Link to="/hello-world">hello-world</Link> */}
        <Link to="/features">features</Link>
        {/* <Link to="/terms-privacy-policy-old">terms-privacy-policy-</Link> */}
      </div>
    </div>
  );
};

export default Resource;
